import React, { useState, useContext, useCallback, useEffect } from 'react'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import Modal from './Modal'
import { sendFeedbackPersonal} from '../../api/api'
import css from './Modal.module.scss'
import lCss from '../Layout/Layout.module.scss'
import {ERRORS_FORM_FEEDBACK_PERSONAL, FORM} from "../../constant"
import {ModalContext} from "../../context"

export default function ModalAbout({isOpen,closeModal}) {
	const { executeRecaptcha } = useGoogleReCaptcha()
	const { toggleModal } = useContext(ModalContext)
	const [ form, setForm ] = useState({[FORM.NAME]: '', [FORM.EMAIL]: '', [FORM.SUBJECT]: '', [FORM.MESSAGE]:'', [FORM.POLICY]: 0, [FORM.RECAPTCHA]: ''})
	const [ state, setState ] = useState({error: '', focus: false})
	const { error, focus } = state

	const onChange = function (e) {
		e.stopPropagation()
		const { name, value } = e.target
		setForm(prevState => ({...prevState, [name]: value}))
		setState(prevState => ({...prevState, error: '' }))
	}

	const onCheckbox = (e) =>{
		const { name, checked } = e.target

		setForm(prevState => ({...prevState, [name]: checked ? 1 : 0}))
		setState(prevState => ({...prevState, error: '' }))
	}

	const onFocus = (e) => {
		const { name } = e.target
		setState(prevState => ({...prevState, focus: name }))
	}

	const successMail = function () {
		toggleModal({feedbackPersonal:false, feedbackSuccess:true})
		setForm({[FORM.NAME]: '', [FORM.EMAIL]: '', [FORM.SUBJECT]: '', [FORM.MESSAGE]:'', [FORM.POLICY]: 0, [FORM.RECAPTCHA]: ''})
	}

	const validate = () =>{
		const error = Object.keys(ERRORS_FORM_FEEDBACK_PERSONAL).find(e => (form[e] === '' || !form[e]))
		setState(prevState => ({...prevState, error: ERRORS_FORM_FEEDBACK_PERSONAL[error] }))

		return Boolean(error)
	}

	const onSubmit = async (e) => {
		e.preventDefault()
		if(!validate()) {
			const result = await sendFeedbackPersonal(form);
			if (result?.message?.code === 200) {
				successMail()
			} else {
				closeModal()
			}
		}
	}

	const onClose = function () {
		closeModal()
	}

	const handleReCaptchaVerify = async () => {
		if (!executeRecaptcha) {
			console.log('Execute recaptcha not yet available')
		}else {
			try {
				const token = await executeRecaptcha('load');
				setForm(prevState => ({...prevState, [FORM.RECAPTCHA]: token}));
				return token;
			} catch (e) {
				handleReCaptchaVerify()
			}
		}
	}

	useEffect(() => {
		handleReCaptchaVerify()
	}, [executeRecaptcha])


	return (
		<Modal
			isOpen={isOpen}
			style={{
				overlay: {
					position: 'fixed',
					top: 0,
					left: 0,
					right: 0,
					bottom: 0,
					backgroundColor: 'rgba(0, 0, 0, 0.6)',
					transform:  'none',
					textAlign: 'center',
					zIndex: 99,
					overflow: 'auto',
					padding: '50px 0'
				},
				content: {
					position:'static',
					display: 'inline-block',
					background: '#fff',
					overflow: 'auto',
					border: 'none',
					WebkitOverflowScrolling: 'touch',
					outline: 'none',
					boxShadow: '5px 15px 25px rgba(0, 0, 0, 0.5)',
					borderRadius: 'none',
					padding: '0',
					width:'750px',
					maxWidth: '100%',
					margin: '0 auto'
				}
			}}
			closeModal={onClose}>
				<div className={css.title + ' ' + css.login}>Связаться с нами</div>
				<form className={css.form} onSubmit={onSubmit}>
					<label className={css.field + ' ' +(focus === FORM.NAME ? css.focus : '') + ' ' + (form[FORM.NAME] ? css.hasValue : '')}>
						<span className={css.label}>Ваше имя</span>
						<input
							className={css.input}
							autoComplete="off"
							value={form[FORM.NAME]}
							name={FORM.NAME}
							type="text"
							onFocus={onFocus}
							onChange={onChange}/>
					</label>
					<label className={css.field + ' ' +(focus === FORM.EMAIL ? css.focus : '') + ' ' + (form[FORM.EMAIL] ? css.hasValue : '')}>
						<span className={css.label}>Ваш e-mail</span>
						<input
							className={css.input}
							autoComplete="off"
							value={form[FORM.EMAIL]}
							name={FORM.EMAIL}
							type="email"
							onFocus={onFocus}
							onChange={onChange}/>
					</label>
					<label className={css.field + ' ' +(focus === FORM.SUBJECT ? css.focus : '') + ' ' + (form[FORM.SUBJECT] ? css.hasValue : '')}>
						<span className={css.label}>Тема сообщения</span>
						<input
							className={css.input}
							autoComplete="off"
							value={form[FORM.SUBJECT]}
							name={FORM.SUBJECT}
							type="text"
							onFocus={onFocus}
							onChange={onChange}/>
					</label>
					<label className={css.field + ' ' +(focus === FORM.MESSAGE ? css.focus : '') + ' ' + (form[FORM.MESSAGE] ? css.hasValue : '')}>
						<span className={css.label}>Ваше сообщение</span>
						<textarea
							value={form[FORM.MESSAGE]}
							onChange={onChange}
							onFocus={onFocus}
							name="message"
							className={css.input}/>
					</label>
					<div className={css.field}>
						<label className={css.checkbox}>
							<input className={css.checkboxField} type="checkbox" name={FORM.POLICY} onChange={onCheckbox}/>
							<i className={css.checkboxIcon}/>
							<span className={css.checkboxTitle}>
								<p>Обращаем Ваше внимание, что данная форма обратной связи используется только для взаимодействия с нами по вопросам обработки и защиты персональных данных. Обращения, не связанные с защитой персональных данных, не будут рассмотрены.</p>
								<p>Обработка Ваших персональных данных при направлении Вами обращения осуществляется нами для взаимодействия при решении Вашего вопроса.</p>
								<p>Проставляя галочку Вы подтверждаете, что ознакомлены с <a href="https://россиясегодня.рф/privacy_policy/" target="_blank">описанием процесса обработки</a> Ваших персональных данных и ее законным основанием.</p>
							</span>
						</label>
					</div>
					<div className={css.field}>
						{error
							? <div className={lCss.button + ' ' + lCss.mt20 + ' ' + lCss.w100 + ' ' + lCss.error}>{error}</div>
							: <button disabled={Boolean(!form[FORM.POLICY])} className={lCss.button + ' ' + lCss.mt20 + ' ' + lCss.w250}>
								Отправить
							</button>
						}
					</div>
				</form>
		</Modal>
	)
}